import React, { useEffect, useState } from "react";
import styled from "styled-components";

// Styles
import "../styles/plyr.css";

const VideoContainer = styled.div`
  position: relative;
  z-index: 10;
`;

export const Video = ({ video, id }) => {
  const [player, setPlayer] = useState(null);
  const [isPlayerReady, setIsPlayerReady] = useState(false);

  useEffect(() => {
    if (typeof window !== "undefined" && typeof document !== "undefined") {
      const Plyr = require("plyr");

      setPlayer(
        new Plyr(`#video-${id}`, {
          // loop: { active: true },
          // controls: ["mute", "play-large", "pause"],
          // hideControls: false,
          // clickToPlay: false,
          // playsinline: true,
          // muted: false,
          // volume: 1,
          // vimeo: {
          //   autopause: false,
          //   byline: false,
          //   controls: false,
          // },
          // youtube: {
          //   showinfo: 0,
          //   modestbranding: 1,
          //   controls: 0,
          // },
        })
      );
    }
  }, []);

  useEffect(() => {
    if (player !== null) {
      player.on("playing", () => {
        setIsPlayerReady(true);
      });
    }
  }, [player]);

  if (video !== null) {
    return (
      <VideoContainer className="video-container">
        <div
          className="plyr__video-embed"
          id={`video-${id}`}
          dangerouslySetInnerHTML={{
            __html: video.html,
          }}
        />
      </VideoContainer>
    );
  } else {
    return null;
  }
};
